import { SvgIcon, SxProps } from "@mui/material";
import ChevronRightSvg from "jsx:../../../Images/Icons/FontAwesome/light/chevron-right.svg";

export function ChevronRightIcon(props: SxProps) {
    return (
        <SvgIcon
            component={ChevronRightSvg}
            inheritViewBox
            sx={{
                color: "var(--community-color-secondary-text)",
                ...props,
            }}
        />
    );
}
